import React from 'react';
import styled from 'styled-components';
import { Title } from '../Styles/title';
import { corianderGreen } from '../Styles/colors';
import { TextField } from '@mui/material';

const QuantityInputStyled = styled.input`
    font-size: 15px;
    width: 50px;
    text-align: center;
    border: none;
    outline: none;
`;

const QuantityTitle = {
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '-0.01em',
    color: '#222C31',
};
// height: 24px;
const IncrementContainer = styled(Title)`
    padding-top: 10px;
    display: flex;
    height: auto;
    margin: 10px 0px 0px 0px;
    align-items: center;
`;

const IncrementButton = styled.div`
    width: 30px;
    height: 30px;
    color: ${corianderGreen};
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    cursor: pointer;
    margin: 0px 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    ${({ disabled }) =>
        disabled &&
        `opacity: 0.5;
     pointer-events: none;
     `}
    &:hover {
        background-color: '#81ecec';
    }
`;

export function QuantityInput({ quantity, minQuantity, uom }) {
    return (
        <IncrementContainer>
            <div style={{ ...QuantityTitle, marginRight: '15px' }}>
                <b>Quantity {minQuantity && `(min ${minQuantity})`}</b>
            </div>
            <IncrementButton
                onClick={() => {
                    quantity.setValue(quantity.value - 1);
                }}
                disabled={quantity.value === (minQuantity ? minQuantity : 1)}
            >
                <i
                    className="fas fa-minus-circle"
                    style={{ fontSize: '24px' }}
                ></i>
            </IncrementButton>
            {/* <QuantityInputStyled {...quantity} /> */}
            <TextField
                type="number"
                value={quantity.value}
                onChange={(e) => {
                    const value = parseInt(e.target.value);
                    quantity.setValue(value);
                }}
                onBlur={(e) => {
                    let valToCheck = minQuantity || 1;
                    if (e.target.value === '' || e.target.value < valToCheck) {
                        quantity.setValue(valToCheck);
                    }
                }}
                inputProps={{
                    min: 1,
                    style: { textAlign: 'center' },
                    //onWheel: (e) => e.preventDefault(),
                }}
                sx={{
                    width: '80px',
                    '& .MuiOutlinedInput-root': {
                        height: '32px',
                    },
                    '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button':
                        {
                            '-webkit-appearance': 'none',
                            margin: 0,
                        },
                    '& input[type=number]': {
                        '-moz-appearance': 'textfield',
                    },
                }}
                size="small"
            />
            <IncrementButton
                onClick={() => {
                    quantity.setValue(quantity.value + 1);
                }}
            >
                <i
                    className="fas fa-plus-circle"
                    style={{ fontSize: '24px' }}
                ></i>
            </IncrementButton>
            {uom && (
                <div
                    style={{
                        ...QuantityTitle,
                        marginLeft: '10px',
                        marginBottom: '2px',
                    }}
                >
                    <b>{uom}</b>
                </div>
            )}
        </IncrementContainer>
    );
}
